import React, { useState } from "react";
import api from "../Service/api";
import "./ClientRequirementForm.css";

const AddClientRequirement = () => {

  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    contactNumber: "",
    requirements: [
      {
        text: "",
        frontImage: null,
        backImage: null
      }
    ]
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [resetKey, setResetKey] = useState(0); // 🔥 used to reset file inputs

  // 🔹 Handle normal input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // 🔹 Change requirement text
  const handleRequirementChange = (index, value) => {
    const updated = [...formData.requirements];
    updated[index].text = value;
    setFormData({ ...formData, requirements: updated });
  };

  // 🔹 Handle image upload
  const handleImageChange = (index, type, file) => {
    const updated = [...formData.requirements];
    updated[index][type] = file;
    setFormData({ ...formData, requirements: updated });
  };

  // ➕ Add requirement
  const addRequirement = () => {
    setFormData({
      ...formData,
      requirements: [
        ...formData.requirements,
        { text: "", frontImage: null, backImage: null }
      ]
    });
  };

  // ❌ Remove requirement
  const removeRequirement = (index) => {
    const updated = formData.requirements.filter((_, i) => i !== index);
    setFormData({ ...formData, requirements: updated });
  };

  // 🚀 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("companyName", formData.companyName);
      formDataToSend.append("contactPerson", formData.contactPerson);
      formDataToSend.append("contactNumber", formData.contactNumber);

      formData.requirements.forEach((req, index) => {
        formDataToSend.append(`requirements[${index}].text`, req.text);

        if (req.frontImage) {
          formDataToSend.append(`requirements[${index}].frontImage`, req.frontImage);
        }

        if (req.backImage) {
          formDataToSend.append(`requirements[${index}].backImage`, req.backImage);
        }
      });

      await api.post("/api/company-requirements", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      // ✅ Professional success message
      setMessage("Requirements saved successfully.");
      setMessageType("success");

      // ✅ Reset form
      setFormData({
        companyName: "",
        contactPerson: "",
        contactNumber: "",
        requirements: [
          { text: "", frontImage: null, backImage: null }
        ]
      });

      setResetKey(prev => prev + 1); // 🔥 reset file inputs

      // ⏳ Auto hide message
      setTimeout(() => {
        setMessage("");
      }, 3000);

    } catch (error) {
      setMessage("Failed to save requirements. Please try again.");
      setMessageType("error");

      setTimeout(() => {
        setMessage("");
      }, 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="client-req-container">

      <div className="client-req-title">
        💼 Client Requirement Entry
      </div>

      {message && (
        <div className={`client-alert ${messageType}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="client-req-form">

        {/* COMPANY INFO */}
        <div className="client-req-section">
          <div className="client-req-grid-2">

            <div className="client-req-group">
              <label>Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="client-req-group">
              <label>Contact Person</label>
              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
              />
            </div>

            <div className="client-req-group">
              <label>Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
              />
            </div>

          </div>
        </div>

        {/* REQUIREMENTS */}
        <div className="client-req-section">
          <div className="client-req-section-title">
            Business Requirements
          </div>

          {formData.requirements.map((req, index) => (
            <div key={index} className="client-req-item">

              {/* Text */}
              <div className="client-req-text">
                <input
                  type="text"
                  value={req.text}
                  onChange={(e) =>
                    handleRequirementChange(index, e.target.value)
                  }
                  placeholder={`Requirement ${index + 1}`}
                  required
                />
              </div>

              {/* Images */}
              <div className="client-req-images">

                <div className="client-req-image-group">
                  <label>Front Image (Optional)</label>
                  <input
                    key={`front-${index}-${resetKey}`}
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleImageChange(index, "frontImage", e.target.files[0])
                    }
                  />
                </div>

                <div className="client-req-image-group">
                  <label>Back Image (Optional)</label>
                  <input
                    key={`back-${index}-${resetKey}`}
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleImageChange(index, "backImage", e.target.files[0])
                    }
                  />
                </div>

                {formData.requirements.length > 1 && (
                  <button
                    type="button"
                    className="client-req-remove-btn"
                    onClick={() => removeRequirement(index)}
                  >
                    Remove
                  </button>
                )}

              </div>

            </div>
          ))}

          <button
            type="button"
            className="client-req-add-btn"
            onClick={addRequirement}
          >
            + Add Requirement
          </button>
        </div>

        <button
          type="submit"
          className="client-req-submit"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Requirements"}
        </button>

      </form>
    </div>
  );
};

export default AddClientRequirement;
